import { render, staticRenderFns } from "./PurchaseOrdersForm.vue?vue&type=template&id=4feb8c7b"
import script from "./PurchaseOrdersForm.vue?vue&type=script&lang=js"
export * from "./PurchaseOrdersForm.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrdersForm.vue?vue&type=style&index=0&id=4feb8c7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports